export const ApiConstants = {
    Login: '/auth/sign-in',
    Social_login:'/auth/web-social-login',
    Register: '/auth/sign-up',
    VerifyOtp: '/auth/verify-otp',
    ForgotPassword: '/auth/forgot-password',
    ResetPassword: '/auth/reset-password',
    Profile:'/auth/profile',
    UpdateProfile:'/auth/update-profile',
    ChangePassword:'/auth/change-password',
    LogOut:"/auth/logout",
    ResendOtp :'/auth/resend-otp',
    VerifyEmail :'auth/verify-email',
    VerifyEmailOtp :'/auth/verify-email-otp',

    DeleteAccount:"/auth/delete-account",

    // Faq page
    Faqlist:"/faqs/get",
    // cms page
    Cms:"/cms-pages/detail",

    // Product page 
    Productlist:"/products/get",
    Prodcutdetails:'/products/detail',

    // Home page
    Homepage:'/home/get',

    // get brands list
    BrandList:'/brands/get-list',

    // addres list
    AddressList :'/address/get',
    AddressAdd:"/address/create",
    AddressUpdate:"/address/update",

    AddressDelete:"/address/delete",

    CityList:"/address/cities",
    StateList:"/address/states",
    // shipping addres
    ShippingList :"/shipping-method/get-list",

    // contact us page
    AddContactUs :'/contact-us/create',

    // quotation page
    QuotesList:'/quotes/get',
    QuotesAdd :'/quotes/create',
    QuotesProductAdd :'/quotes/add-product',
    QuotesProductdelete :'/quotes/delete-product',
    QuotesView :'/quotes/detail',
    QuotesUpdate :'/quotes/update',
    QuotesStatusUpdate:"/quotes/status-update",
    QuotesAddressUpdate:"/quotes/update-address",
    QuotesAddExcel:"/quotes/create-excel",
    QuotesImage :"/quotes/quotes-file-path",
    QuotesImageRemove:"/quotes/remove-image",
    QuotesHistory:'/quotes/history',
    QuotesAddresHistory :'/quotes/get-address-history',
    QuotesPdf :'/quotes/download',
    QuotesXlxsPreview :"/quotes/quotes-xlsx-preview",
    QuotesMessageHistory:'/quotes/get-message-history',



    // order page
    OrderAdd:"/order/create",
    OrderGet:'/order/get',
    OrderDetail:'/order/detail',
    OrderCancal:'/order/cancel',
    OrderStatus:'/order/status',



    // notification page
    NotificationList:"notifications/get",
    NotificationUpdate:"notifications/update",


    // /currency/get

    currencyget :"/currency/get"

}   
export const SocketConstants = {
    GetMessageList: 'chats_list',
    GetMessageListResp: 'chats_list_response',
    SendMessage:"send_message"
}